import { render, staticRenderFns } from "./InSwitchLED80.vue?vue&type=template&id=196a5c2a&scoped=true&"
import script from "./InSwitchLED80.vue?vue&type=script&lang=js&"
export * from "./InSwitchLED80.vue?vue&type=script&lang=js&"
import style0 from "./InSwitchLED80.vue?vue&type=style&index=0&id=196a5c2a&lang=scss&scoped=true&"
import style1 from "./InSwitchLED80.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196a5c2a",
  null
  
)

export default component.exports